import { ABOUTBANNER_GET_LIST,ABOUTBANNER_GET_LIST_SUCCESS,ABOUTBANNER_GET_LIST_ERROR } from "../../../redux/contants";

import { all, fork, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { apiBaseUrl } from '../../../constants/defaultValues';

function* fetchAboutBannerAPI() {
  // alert('saga')
  try {
      // const subscriberDetails = yield Axios.get(`Role/GetRoleList`).then(response => response.data);
      // alert("c")
        const config = {
          method: 'get',
          url: `${apiBaseUrl}BannerContent/GetBannerContentList`,
          headers: { 
            'Accept': 'text/plain', 
            'Authorization': '<API Key>'
          }
        };
        const config_2 = {
          method: 'get',
          url: `${apiBaseUrl}OurValue/GetMaintitleList`,
          headers: { 
            'Accept': 'text/plain', 
            'Authorization': '<API Key>'
          }
        };
        const aboutbannerdetails = yield axios(config).then(response => response.data.Data);
        const Maindetails = yield axios(config_2).then(response => response.data.Data);
        Maindetails.forEach(element => {
          if(element.Type === "OurJourney")
          {
            //const obj = {Main_title_detail: element};
            aboutbannerdetails.push(element);
          }
        });
      // console.log(subscriberDetails,"============")
      yield put({ type: ABOUTBANNER_GET_LIST_SUCCESS, data: aboutbannerdetails });
  } catch (error) {
      yield put({ type: ABOUTBANNER_GET_LIST_ERROR, error });
  }
}


export function* watchAboutBanner() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(ABOUTBANNER_GET_LIST, fetchAboutBannerAPI);

}

export default function* rootSaga() {
    yield all([
        fork(watchAboutBanner),
    ]);
}